import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {constants} from '../app-constants';
import {UsuarioLogadoModel} from '../model';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class AuthGuard implements CanActivate {

  private _cookieValue = 'UNKNOWN';

  constructor(private router: Router,
              private cookieService: CookieService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const usuarioLogadoModel: UsuarioLogadoModel = JSON.parse( localStorage.getItem(constants.usuarioLogadoKey) );
    if (usuarioLogadoModel) {
      if ( usuarioLogadoModel.token ) {
        return true; // logged in so return true
      }
    }
    this._cookieValue = this.cookieService.get('idEmpresa');
    if (this._cookieValue === undefined || this._cookieValue == null || this._cookieValue === 'UNKNOWN') {
      this.cookieService.set( 'idEmpresa', usuarioLogadoModel.idEmpresa);
    }
    localStorage.clear(); // remove user from local storage to log user out

    if (usuarioLogadoModel != null) {
      this.router.navigate(['/login'], { queryParams: { idEmpresa: usuarioLogadoModel.idEmpresa } });
    } else {
      this.router.navigate(['/login'], { queryParams: { idEmpresa: ''} });
    }
    return false;
  }
}
